// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__c0vRN","form":"NotFound_form__wpLru","limiter":"NotFound_limiter__GQPjm","message":"NotFound_message__ElfIb","accent":"NotFound_accent__NZFzO"};